import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { makeStyles } from '@material-ui/core';
import { DatePicker, DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        height: "calc(1.5em + 0.75rem + 2px)"
    }
}))

export const DateTime = (props) => {
    const classes = useStyles()
    var classProperties = (props.className ? props.className : '')
    var readonly = props.readonly ? true : false
    var required = props.required ? true : false

    var GetValue = (value) => {
        if (value === null || value === undefined || value === "") return null
        var day = value.getDate().toString().padStart(2, '0')
        var month = (value.getMonth() + 1).toString().padStart(2, '0')
        var year = value.getFullYear().toString()
        return year + "-" + month + "-" + day + "T" + value.toTimeString().substring(0, 8)
    }

    return (
        <React.Fragment>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DateTimePicker
                    value={props.value ? props.value : null}
                    name={props.name}
                    onChange={(value) => { props.onChange(GetValue(value)) }}
                    format="dd/MMM/yyyy HH:mm"
                    className={classProperties + (readonly ? " boldInput " : " ") + classes.root}
                    label={props.label}
                    disabled={readonly}
                    required={required}
                />
            </MuiPickersUtilsProvider>
            {props.error ? <p className="errorMessage">{props.error}</p> : null}
        </React.Fragment>
    );
}

export const Date = (props) => {
    const classes = useStyles()
    var classProperties = (props.className ? props.className : '');
    var readonly = props.readonly ? true : false;
    var required = props.required ? true : false;

    return (
        <React.Fragment>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                    value={props.value ? props.value : null}
                    name={props.name}
                    onChange={(value) => props.onChange(value.toISOString().substring(0, 11) + value.toTimeString().substring(0, 8))}
                    format="dd/MMM/yyyy"
                    className={classProperties + (readonly ? " boldInput " : " ") + classes.root}
                    label={props.label}
                    disabled={readonly}
                    required={required}
                />
            </MuiPickersUtilsProvider>
            {props.error ? <p className="errorMessage">{props.error}</p> : null}
        </React.Fragment>
    );
}

export const MonthYear = (props) => {
    const classes = useStyles()
    var classProperties = (props.className ? props.className : '');
    var readonly = props.readonly ? true : false;
    var required = props.required ? true : false;

    return (
        <React.Fragment>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                    views={['year', 'month']}
                    value={props.value ? props.value.substring(0, 7) + "-01T12:00:00" : null}
                    name={props.name}
                    onChange={(value) => props.onChange(value.toISOString().substring(0, 7) + "-01T12:00:00")}
                    format="MMM/yyyy"
                    className={classProperties + (readonly ? " boldInput " : " ") + classes.root}
                    label={props.label}
                    disabled={readonly}
                    required={required}
                />
            </MuiPickersUtilsProvider>
            {props.error ? <p className="errorMessage">{props.error}</p> : null}
        </React.Fragment>
    );
}

export const ToShortDate = (passedDate) => {
    if (passedDate === null || passedDate === "") return ""
    if (typeof (passedDate) === "string") passedDate = new window.Date(passedDate)

    let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    let day = passedDate.getDate()
    let monthIndex = passedDate.getMonth()
    let monthName = monthNames[monthIndex]
    let year = passedDate.getFullYear()

    return `${day}/${monthName}/${year}`
}

export const ToShortMonthYear = (passedDate) => {
    if (passedDate === null || passedDate === "") return ""
    if (typeof (passedDate) === "string") passedDate = new window.Date(passedDate)

    let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    let monthIndex = passedDate.getMonth()
    let monthName = monthNames[monthIndex]
    let year = passedDate.getFullYear()

    return `${monthName}/${year}`
}